module.exports = __webpack_public_path__ + "static/media/food.2cc8a1ab.jpg";